import Choices from "choices.js";
import Sortable from "sortablejs";

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("dashboard-widgets-container");
  if (!container) return;

  const layoutStr = container.dataset.layout;
  const layout = layoutStr ? layoutStr.split(",") : [];

  // Hide missing widgets and check modal checkboxes
  document.querySelectorAll(".dashboard-widget").forEach((el) => {
    const id = el.dataset.widgetId;
    if (!layout.includes(id)) {
      el.style.display = "none";
    }
  });

  document.querySelectorAll(".widget-toggle-checkbox").forEach((cb) => {
    cb.checked = layout.includes(cb.value);
    cb.addEventListener("change", function () {
      const id = this.value;
      const widgetEl = document.querySelector(`.dashboard-widget[data-widget-id="${id}"]`);
      if (widgetEl) {
        widgetEl.style.display = this.checked ? "block" : "none";
        saveLayout();
      }
    });
  });

  // Fix ARIA hidden focus issue on modal close
  const widgetModal = document.getElementById("widgetModal");
  if (widgetModal) {
    widgetModal.addEventListener("hide.bs.modal", function () {
      if (document.activeElement && widgetModal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    });
  }

  // Initialize Sortable
  const sortable = Sortable.create(container, {
    animation: 150,
    handle: ".card-header",
    ghostClass: "bg-light",
    disabled: true,
    onEnd: function (evt) {
      saveLayout();
    },
  });

  const toggleSortBtn = document.getElementById("toggleSortModeBtn");
  if (toggleSortBtn) {
    let isSortableActive = false;
    toggleSortBtn.addEventListener("click", function () {
      isSortableActive = !isSortableActive;
      sortable.option("disabled", !isSortableActive);

      if (isSortableActive) {
        container.classList.add("sortable-active");
        toggleSortBtn.classList.remove("btn-outline-secondary");
        toggleSortBtn.classList.add("btn-secondary");
        toggleSortBtn.innerHTML = '<i class="bi bi-arrows-move me-1"></i>';
      } else {
        container.classList.remove("sortable-active");
        toggleSortBtn.classList.add("btn-outline-secondary");
        toggleSortBtn.classList.remove("btn-secondary");
        toggleSortBtn.innerHTML = '<i class="bi bi-lock me-1"></i>';
      }
    });
  }

  // KPI quick ranges: fill the date inputs and submit
  const kpiRangeForm = document.querySelector("[data-kpi-range-form]");
  if (kpiRangeForm) {
    kpiRangeForm.querySelectorAll("[data-kpi-days]").forEach((btn) => {
      btn.addEventListener("click", function () {
        const to = new Date();
        const from = new Date(to);
        if (this.dataset.kpiDays === "year") {
          from.setMonth(0, 1);
        } else {
          from.setDate(from.getDate() - Number(this.dataset.kpiDays));
        }
        kpiRangeForm.elements.kpiFrom.value = formatDate(from);
        kpiRangeForm.elements.kpiTo.value = formatDate(to);
        kpiRangeForm.submit();
      });
    });
  }

  // Vertriebscockpit: show only the selected locations (all when none is picked)
  const cockpitSelect = document.querySelector("[data-cockpit-standorte]");
  if (cockpitSelect) {
    const rows = document.querySelectorAll("#collapseVertriebscockpit tr[data-standort-id]");
    const choices = new Choices(cockpitSelect, {
      removeItemButton: true,
      placeholderValue: "Alle Standorte",
      searchPlaceholderValue: "Standort suchen",
      noResultsText: "Kein Standort gefunden",
      noChoicesText: "Alle Standorte ausgewählt",
      itemSelectText: "",
      shouldSort: false,
    });
    const filterRows = () => {
      const selected = choices.getValue(true);
      rows.forEach((row) => {
        const isShown = selected.length === 0 || selected.includes(row.dataset.standortId);
        row.classList.toggle("d-none", !isShown);
      });
    };
    cockpitSelect.addEventListener("change", filterRows);
    filterRows();
  }

  function formatDate(date) {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    return `${dd}.${mm}.${date.getFullYear()}`;
  }

  function saveLayout() {
    const widgets = Array.from(document.querySelectorAll(".dashboard-widget"))
      .filter((el) => el.style.display !== "none")
      .map((el) => el.dataset.widgetId);

    const csrfHeader = document.querySelector("meta[name='_csrf_header']");
    const csrfToken = document.querySelector("meta[name='_csrf']");

    if (!csrfHeader || !csrfToken) {
      console.error("CSRF tokens missing");
      return;
    }

    fetch("/api/profile/dashboard/layout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        [csrfHeader.content]: csrfToken.content,
      },
      body: JSON.stringify(widgets),
    }).then((response) => {
      if (!response.ok) {
        console.error("Failed to save layout");
      }
    });
  }
});
